import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Weekly Campaign Targets", -1);
var _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  "class": "mb-8 leading-normal"
}, "Sorry you do not have any tenant associated with your account.", -1);
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = {
  "class": "flex justify-between mb-8"
};
var _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "text-3xl font-bold"
}, "Weekly Campaign Targets", -1);
var _hoisted_7 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_8 = {
  "class": "w-1/2 flex"
};
var _hoisted_9 = {
  "class": "w-1/2"
};
var _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  "class": "w-full p-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Tenant")], -1);
var _hoisted_11 = {
  "class": "w-full p-2"
};
var _hoisted_12 = {
  "class": "w-1/2"
};
var _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  "class": "w-full p-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Campaign")], -1);
var _hoisted_14 = {
  "class": "w-full p-2"
};
var _hoisted_15 = {
  "class": "bg-grey-100 rounded-md shadow overflow-x-auto mb-6"
};
var _hoisted_16 = ["onUpdate:modelValue"];
var _hoisted_17 = ["onUpdate:modelValue"];
var _hoisted_18 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  return $props.tenantList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    title: "Dashboard"
  }), _hoisted_2, _hoisted_3])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_Head, {
    title: "Weekly Campaign Targets"
  }), _createElementVNode("div", _hoisted_5, [_hoisted_6, $props.user_type == 'admin' ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.getNoTargetReport && $options.getNoTargetReport.apply($options, arguments);
    }),
    "class": "ml-8 btn-primary-smaller"
  }, "Campaigns without target")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_select, {
    modelValue: $data.tenant,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.tenant = $event;
    }),
    filterable: "",
    onChange: _cache[2] || (_cache[2] = function ($event) {
      return $options.getCampaignList();
    }),
    clearable: ""
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenantList, function (t, t_key) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: t,
          label: t
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_select, {
    modelValue: $data.campaign,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.campaign = $event;
    }),
    filterable: "",
    onChange: _cache[4] || (_cache[4] = function ($event) {
      return $options.getMemberList();
    }),
    clearable: ""
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.campaignList, function (c, c_key) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: c.id,
          label: c.name
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])])])])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_skeleton, {
    loading: $data.campaignTargetList,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table, {
        data: $data.memberList,
        style: {
          "width": "100%"
        }
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "Campaigner",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            label: "Contacts target per week",
            align: "center"
          }, {
            "default": _withCtx(function (scope) {
              return [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return scope.row.contacts = $event;
                },
                type: "number"
              }, null, 8, _hoisted_16), [[_vModelText, scope.row.contacts]])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "Companies target per week",
            align: "center"
          }, {
            "default": _withCtx(function (scope) {
              return [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return scope.row.companies = $event;
                },
                type: "number"
              }, null, 8, _hoisted_17), [[_vModelText, scope.row.companies]])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "Save",
            width: "100"
          }, {
            "default": _withCtx(function (scope) {
              return [_createElementVNode("button", {
                onClick: function onClick($event) {
                  return $options.saveData(scope.row);
                },
                "class": "btn-primary-smaller"
              }, "Save", 8, _hoisted_18)];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data"])];
    }),
    _: 1
  }, 8, ["loading"])])]));
}